import React from 'react'
// import InputField from '../components/InputField'
import InputField from '../../../sharedcomponents/1elements/Fields/InputField'
import { makeStyles } from '@material-ui/core/styles'

const LeftChild = ({
  formikProps,
  editMode,
  createMode,
  serviceTypes,
  serviceCategories
}) => {
  const classes = useStyles()
  const values = formikProps.values

  return (
    <div className={classes.root}>
      <div className={classes.leftPanel}>
        <InputField
          type='text'
          name='name'
          maxLength={150}
          required={true}
          label='Service Name'
          value={values?.name}
          editMode={editMode}
        />
        <InputField
          type='phone'
          name='phone'
          label='Phone Number'
          value={values?.phone}
          values={values}
          setFieldValue={formikProps.setFieldValue}
          editMode={editMode}
        />
        <InputField
          type='select'
          name='category_id'
          options={
            serviceCategories &&
            serviceCategories.map(oneOption => ({
              key: oneOption.id,
              value: oneOption.id,
              text: oneOption.name
            }))
          }
          label='Category'
          value={values?.category_id}
          editMode={editMode}
          setFieldValue={formikProps.setFieldValue}
        />
      </div>
      <div className={classes.rightPanel}>
        <InputField
          type='email'
          name='email'
          maxLength={150}
          required={true}
          label='Email'
          value={values?.email}
          editMode={editMode}
        />
        <InputField
          type='select'
          name='type_id'
          options={
            serviceTypes &&
            serviceTypes.map(oneOption => ({
              key: oneOption.id,
              value: oneOption.id,
              text: oneOption.name
            }))
          }
          label='Type'
          value={values?.type_id}
          editMode={editMode}
          setFieldValue={formikProps.setFieldValue}
        />
      </div>
    </div>
  )
}

export default React.memo(LeftChild)

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    '& >*': {
      boxSizing: 'border-box'
    }
  },
  leftPanel: {
    width: '60%',
    display: 'flex',
    flexDirection: 'column',
    padding: '0 10px 0 0'
  },
  rightPanel: {
    width: '40%',
    display: 'flex',
    flexDirection: 'column',
    padding: '0 0 0 10px'
  }
}))
